export default {
    // baseUrl: 'http://localhost:9655',
    baseUrl: 'https://www.jh188.vip',
}



// WEBPACK FOOTER //
// ./src/assets/js/config.js